(function ($, angular, window) {
    // To turn on console logging, turn this flag to true;
    window.THFLogging = false;

    'use strict';
    /**
     * Please NOTE: This directive is used to get equal height rows for the compare table that is based on
     * columns and the rows are not in a format that can be easily auto height-resize using css.
     */
    window.THF.Angular.LiveQuoteTool.directive('productSelector', ['ngDialog', 'ProductsModel', function (ngDialog, PM) {
        function debugLog(msg) {
            if (window.THFLogging === true) {
                if (console && console.log) {
                    console.log('[LQT.productSelector]', msg);
                }
            }
        }


        var link = function (scope, elem, attrs) {
            debugLog('directive link');
            scope.className = attrs.className;
            scope.coverHeading = attrs.coverHeading;
            scope.subLimitsDisclaimer = attrs.sublimitsDisclaimer;

            scope.spriteUrlAdd = THF.SiteSettings.svgSprite + '#ui-add';
            scope.spriteUrlCheck = THF.SiteSettings.svgSprite + '#ui-covered';
            scope.spriteUrlUp = THF.SiteSettings.svgSprite + '#ui-up';
            scope.spriteUrlDown = THF.SiteSettings.svgSprite + '#ui-down';
            scope.spriteUrlLeft = THF.SiteSettings.svgSprite + '#ui-left';
            scope.spriteUrlRight = THF.SiteSettings.svgSprite + '#ui-right';
            scope.spriteUrlTooltip = THF.SiteSettings.svgSprite + '#ui-tooltip';

            scope.sliderButtonInactive = {
                left: true,
                right: false
            };

            scope.serviceGroupInactive = {};

            /**
             *
             *
             * Slider functionality for the product selection.
             *
             *
             */

            /**
             * The current slide.
             * @type {number}
             */
            var currentSlide = 0;

            var alternateSelectedProduct;
            var hiddenProduct;

            scope.$watch('selectedProduct', function (newVal, oldVal) {
                if (scope.className == 'hospital') {
                    hideProducts(newVal, scope.allSelectedProducts);
                }
            });

            scope.$watch('allSelectedProducts', function (newVal, oldVal) {
                hideProducts(scope.selectedProduct, newVal);
            });

            scope.moveProductsLeft = function ($event) {
                debugLog('moveProductsLeft()');
                $event.preventDefault();

                // Get the number of items
                // Get the slider width
                // Get the left margin
                // set the left margin to (left margin + slider width)
                // Decrement the current slide.

                // Yes this needs to be calculated every time as angular removes items under specific circumstances.
                var parent = $($event.delegateTarget).parents('.lqt-compare-table');
                var slider = $('.slider', parent);
                var slides = $('.slide', slider);
                var slideWidth = slides.outerWidth();

                if (currentSlide > 0) {
                    currentSlide--;

                    slider.css({
                        'margin-left': 0 - (currentSlide * slideWidth) + 'px'
                    }, 200);
                }

                updateSliderButtonState($event);


                /*var product = scope.products.pop();
                 scope.products.unshift(product);

                 if(product.id == scope.selectedProduct.id ) {
                 scope.products.unshift(scope.products.pop());
                 }
                 */
            };

            scope.moveProductsRight = function ($event) {
                debugLog('moveProductsRight()');
                $event.preventDefault();

                // Get the number of items
                // Get the slider width
                // Get the left margin
                // set the left margin to (left margin - slider width)
                // Increment the current slide.

                // Yes this needs to be calculated every time as angular removes items under specific circumstances.
                var parent = $($event.delegateTarget).parents('.lqt-compare-table');
                var slider = $('.slider', parent);
                var slides = $('.slide', slider);
                var slideWidth = slides.outerWidth();
                var numberSlides = slides.length / 2; // We divide by 2 as we have added another set of the same items in to allow the slider to function correctly.

                var maxSlides = (numberSlides - 1); // We want to exclude the last item as it makes it the first item in the list.

                if (currentSlide < maxSlides) {
                    currentSlide++;

                    slider.css({
                        'margin-left': 0 - (currentSlide * slideWidth) + 'px'
                    }, 200);
                }

                updateSliderButtonState($event);

                /*
                 var product = scope.products.shift();
                 scope.products.push(product);

                 if(product.id == scope.selectedProduct.id ) {
                 scope.products.push(scope.products.shift());
                 }
                 */
            };

            function updateSliderButtonState($event) {
                // Yes this needs to be calculated every time as angular removes items under specific circumstances.
                var parent = $($event.delegateTarget).parents('.lqt-compare-table');
                var slider = $('.slider', parent);
                var slides = $('.slide', slider);
                var numberSlides = slides.length / 2; // We divide by 2 as we have added another set of the same items in to allow the slider to function correctly.
                var maxSlides = (numberSlides - 1); // We want to exclude the last item as it makes it the first item in the list.

                if (currentSlide == 0) {
                    scope.sliderButtonInactive.left = true;
                    scope.sliderButtonInactive.right = false;
                } else if (currentSlide == maxSlides) {
                    scope.sliderButtonInactive.left = false;
                    scope.sliderButtonInactive.right = true;
                } else {
                    scope.sliderButtonInactive.left = false;
                    scope.sliderButtonInactive.right = false;
                }
            }

            scope.sliderSwipeLeft = function ($event) {
                scope.moveProductsRight($event);
            };

            scope.sliderSwipeRight = function ($event) {
                scope.moveProductsLeft($event);
            };


            scope.toggleAccordion = function ($event, accordionLabel) {
                debugLog('toggleAccordion()');
                var clickElem = $($event.target);
                if (!$(clickElem).hasClass('accordion-arrow')) {
                    clickElem = $(clickElem).parents('.accordion-arrow');
                }
                var serviceGroup = clickElem.attr('data-accordion-service-group');

                if (typeof scope.serviceGroupInactive[serviceGroup] !== 'undefined' && scope.serviceGroupInactive[serviceGroup] === true) {
                    scope.serviceGroupInactive[serviceGroup] = false;

                    DSTAPI.track('event', {
                        category: 'Live Quote Tool Results Page Interaction',
                        action: 'Hospital - Tab Expansion',
                        label: accordionLabel
                    });
                } else {
                    scope.serviceGroupInactive[serviceGroup] = true;
                }
            };

            scope.updateProduct = function ($event, product) {
                debugLog('updateProduct()');
                $event.preventDefault();
                $event.stopPropagation();


                // We need to remove an item if the there is an option set to do so.
                hideProducts(product, scope.allSelectedProducts);
                selectCombinedProduct(product);
            };

            function selectCombinedProduct(product) {
                // If the product is combined we need to update both the hospital
                // and the extras cover to the correct product.
                if (scope.selectedProduct.combined) {
                    debugLog('Deselecting Combined Cover.');
                    var productCode = 'Mid3';
                    if (scope.className == 'hospital') {
                        productCode = 'EHC';
                    }

                    getRelatedProductByProductCode(productCode, function (relatedProduct) {
                        modalDeSelectingCombinedCover(product, relatedProduct);
                    });

                } else {
                    debugLog('Selecting product.');
                    if (product.combined) {
                        debugLog('Selected product is combined.');
                        var combinedRelatedId = product.combinedProductId;
                        getRelatedProductById(combinedRelatedId, function (relatedProduct) {
                            modalSelectingCombinedCover(product, relatedProduct);
                        });

                    } else {
                        scope.selectedProduct = product;
                    }
                }
            }

            scope.productMouseEnter = function ($event) {
                debugLog('productMouseEnter()');
                var parent = $($event.delegateTarget);

                var colourProduct = parent.attr('data-colour-product');
                var colourLight = parent.attr('data-colour-light');
                var colourDark = parent.attr('data-colour-dark');

                $('a.product-label', parent).css({
                    'background-color': colourProduct,
                    'color': colourDark
                });
                $('.extra-info', parent).css({
                    'background-color': colourDark,
                    'color': colourProduct
                });
                $('.services', parent).css({
                    'background-color': colourLight
                });
            };

            scope.productMouseLeave = function ($event) {
                debugLog('productMouseLeave()');
                var parent = $($event.delegateTarget);

                var colourProduct = parent.attr('data-colour-product');
                var colourLight = parent.attr('data-colour-light');
                var colourDark = parent.attr('data-colour-dark');

                $('a.product-label', parent).css({
                    'background-color': 'transparent'
                });
                $('.extra-info', parent).css({
                    'background-color': colourProduct,
                    'color': colourDark
                });
                $('.services', parent).css({
                    'background-color': 'transparent'
                });
            };

            var firstOpen = true;

            scope.$watchGroup([
                'panel'
            ], function () {
                if (firstOpen && scope.panel) {
                    debugLog('Panel Updated Setup Open ServiceGroups');
                    var $serviceGroups = $('[data-accordion-service-group]', $('.lqt-compare-table.' + scope.className));
                    $serviceGroups.each(function (index) {
                        var show = true;
                        if (index == 0) {
                            show = false;
                        }
                        scope.serviceGroupInactive[$(this).attr('data-accordion-service-group')] = show;
                    });
                    firstOpen = false;
                }
            });

            function modalSelectingCombinedCover(product, relatedProduct) {
                debugLog('modalSelectingCombinedCover()');
                ngDialog.open({
                    template: 'modal-combined-cover-selecting',
                    className: 'ngdialog-theme-plain combined-cover selecting',
                    controller: ['$scope', function ($scope) {
                        $scope.onContinue = function ($event) {
                            $event.preventDefault();

                            scope.selectedProduct = product;
                            assignRelatedProduct(relatedProduct);
                            $scope.closeThisDialog();
                        };

                        $scope.onClose = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };
                    }],
                    scope: scope
                });
            }

            function hideProducts(product, allSelectedProducts) {
                debugLog('hideProducts()');
                if (JSON.stringify(allSelectedProducts.hospital) == JSON.stringify({})) {
                    return;
                }
                if (JSON.stringify(allSelectedProducts.extras) == JSON.stringify({})) {
                    return;
                }

                if (scope.className == 'hospital') {
                    alternateSelectedProduct = allSelectedProducts.extras;
                } else {
                    alternateSelectedProduct = allSelectedProducts.hospital;
                }

                if (typeof product.removeExtrasProductId !== 'undefined') {
                    if (scope.className == 'hospital' && product.removeExtrasProductId != 0) {
                        hiddenProduct = getRelatedProductByIdByReference(product.removeExtrasProductId);
                        if (hiddenProduct.id == alternateSelectedProduct.id) {
                            getRelatedProductByProductCode('EHC', function (relatedProduct) {
                                scope.allSelectedProducts.extras = relatedProduct;
                            });
                        }
                        hiddenProduct.display = false;
                    } else if (scope.className == 'hospital' && product.removeExtrasProductId == 0) {
                        if (typeof hiddenProduct !== 'undefined') {
                            hiddenProduct.display = true;
                        }
                    }
                }
            }

            function modalDeSelectingCombinedCover(product, relatedProduct) {
                debugLog('modalDeSelectingCombinedCover()');
                ngDialog.open({
                    template: 'modal-combined-cover-deselecting',
                    className: 'ngdialog-theme-plain combined-cover deselecting',
                    controller: ['$scope', function ($scope) {
                        if (scope.className == 'hospital') {
                            $scope.coverType = 'Extras';
                        } else if (scope.className == 'extras') {
                            $scope.coverType = 'Hospital';
                        }


                        $scope.onContinue = function ($event) {
                            $event.preventDefault();
                            scope.selectedProduct = product;
                            assignRelatedProduct(relatedProduct);
                            $scope.closeThisDialog();
                        };

                        $scope.onClose = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };
                    }],
                    scope: scope
                });
            }

            function getRelatedProductByIdByReference(productId) {
                var products = [];
                debugLog('getRelatedProductById()');
                if (scope.className == 'hospital') {
                    products = _.filter(scope.allProducts.extras, {id: productId});
                } else if (scope.className == 'extras') {
                    products = _.filter(scope.allProducts.hospital, {id: productId});
                }
                return (products.length === 1) ? products[0] : products;
            }

            function getRelatedProductById(productId, callback) {
                debugLog('getRelatedProductById()');
                if (typeof callback === 'function') {
                    if (scope.className == 'hospital') {
                        PM.byProductId('extras', productId).then(function (products) {
                            var product = (products.length > 0) ? products[0] : products;
                            callback.apply(null, [product]);
                        });
                        // products = _.filter(scope.allProducts.extras, {id: productId});
                    } else if (scope.className == 'extras') {
                        PM.byProductId('hospital', productId).then(function (products) {
                            var product = (products.length > 0) ? products[0] : products;
                            callback.apply(null, [product]);
                        });
                        // products = _.filter(scope.allProducts.hospital, {id: productId});
                    }
                } else {
                    debugLog('getRelatedProductById(): Not a valid callback.');
                }
            }

            function getRelatedProductByProductCode(productCode, callback) {
                debugLog('getRelatedProductByProductCode()');
                if (typeof callback === 'function') {
                    var products = [];
                    if (scope.className == 'hospital') {
                        PM.byProductCode('extras', productCode).then(function (products) {
                            var product = (products.length > 0) ? products[0] : products;
                            callback.apply(null, [product]);
                        });
                        // products = _.filter(scope.allProducts.extras, {id: productId});
                    } else if (scope.className == 'extras') {
                        PM.byProductCode('hospital', productCode).then(function (products) {
                            var product = (products.length > 0) ? products[0] : products;
                            callback.apply(null, [product]);
                        });
                    }
                } else {
                    debugLog('getRelatedProductByProductCode(): Not a valid callback.');
                }
            }

            function assignRelatedProduct(relatedProduct) {
                debugLog('assignRelatedProduct()');
                if (scope.className == 'hospital') {
                    scope.allSelectedProducts.extras = relatedProduct;
                } else if (scope.className == 'extras') {
                    scope.allSelectedProducts.hospital = relatedProduct;
                }
            }
        };

        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'model': '=',
                'tab': '=',
                'show': '=',
                'panel': '=',
                'serviceTypes': '=',
                'selectedProduct': '=',
                'products': '=',
                'allSelectedProducts': '=',
                'allProducts': '=',
                'coverText': '=',
            },
            'link': link,
            'templateUrl': function () {
                return THF.Utility.Location.cacheBustUrl('/static/views/live-quote-tool/productSelector.html');
            }
        };
    }]);
})(jQuery, angular, window);
